<template>
    <svg
       width="20"
       height="20"
       viewBox="0 0 20 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
       >
       <path
           d="M1.72501 3.83334C2.39167 0.950004 6.73334 0.950004 7.39167 3.83334C7.78334 5.525 6.70834 6.95834 5.77501 7.85C5.09167 8.5 4.01667 8.49167 3.33334 7.85C2.40834 6.95834 1.33334 5.525 1.72501 3.83334Z"
           :stroke="iconColor"
           stroke-width="1.5"
       />
       <path
           d="M12.5583 13.8333C13.225 10.95 17.5917 10.95 18.2583 13.8333C18.65 15.525 17.575 16.9583 16.6333 17.85C15.95 18.5 14.8667 18.4917 14.1833 17.85C13.2417 16.9583 12.1667 15.525 12.5583 13.8333Z"
           :stroke="iconColor"
           stroke-width="1.5"
       />
       <path
           d="M9.99997 4.16699H12.2333C13.775 4.16699 14.4916 6.07533 13.3333 7.09199L6.67497 12.917C5.51664 13.9253 6.23331 15.8337 7.76664 15.8337H9.99997"
           :stroke="iconColor"
           stroke-width="1.5"
           stroke-linecap="round"
           stroke-linejoin="round"
       />
       <path
           d="M4.57185 4.58366H4.58148"
           :stroke="iconColor"
           stroke-width="2"
           stroke-linecap="round"
           stroke-linejoin="round"
       />
       <path
           d="M15.4052 14.5837H15.4148"
           :stroke="iconColor"
           stroke-width="2"
           stroke-linecap="round"
           stroke-linejoin="round"
       />
       </svg>
 </template>
 <script setup>
 import { defineProps, inject } from 'vue';

 const $filters = inject('$filters');
 const props = defineProps({
   color: {
     type: String,
     default: null,
   },
 });

 const iconColor = props.color || $filters.iconColor();

 </script>
